import React, {useEffect} from 'react';
import './experience.css';
import {HiOutlineBuildingOffice2} from 'react-icons/hi2';
import {FaRegBuilding} from 'react-icons/fa';
import {BiLandscape} from 'react-icons/bi';
import {AiOutlineHome, AiOutlinePartition} from 'react-icons/ai';
import Aos from "aos";
import 'aos/dist/aos.css'

const services = [
    { title: "Interior Sketch", icon: <AiOutlineHome />, desc: "Detailed interior illustrations with a hand-drawn/realistic feel" },
    { title: "Exterior Sketch", icon: <FaRegBuilding />, desc: "Architectural facades and outdoor perspective views" },
    { title: "2D Floor Plan", icon: <AiOutlinePartition />, desc: "A building's 2d layout that provides a clear view of the space"},
    { title: "3D Floor Plan", icon: <AiOutlinePartition />, desc: "A virtual 3d model to visualize the space"},
    { title: "Architectural Sketch", icon: <HiOutlineBuildingOffice2 />, desc: "Concept drawings for buildings and structures" },
    { title: "Landscape", icon: <BiLandscape />, desc: "Garden and outdoor space design visuals" }
];

const Experience = () => {
    useEffect(() => {
        Aos.init({duration:1500})
    }, [])

    return (
        <section id='experience'>
            <div data-aos='fade-up' data-aos-duration='2000' className='experience_header'>
                <h2 className="eyebrow">What sketches I draw</h2>
                <h1>Services</h1>
            </div>
            <div data-aos='zoom-in' data-aos-duration='2000' className='container experience_container'>
                <div className='experience_content'>
                    {services.map((service, i) => (
                        <article className='experience_details' key={i}>
                            <div className='experience_details_icon'>{service.icon}</div>
                            <div>
                                <h2>{service.title}</h2>
                                <p className='experience_desc'>{service.desc}</p>
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Experience;
